/** @format */
import { ButtonSkeleton } from '@mpb-com/feather/components/atoms/button/skeleton';
import { HeadingSkeleton } from '@mpb-com/feather/components/atoms/heading/skeleton';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React from 'react';

import { SectionPreviewBlockSkeletonProps } from '../types';
import { StyledSectionPreviewBlockSkeleton } from './skeleton.styles';

export const SectionPreviewBlockSkeleton = ({
    variant,
    imagePosition,
    'data-testid': dataTestId,
}: SectionPreviewBlockSkeletonProps) => {
    return (
        <StyledSectionPreviewBlockSkeleton
            variant={variant}
            imagePosition={imagePosition}
            data-testid={dataTestId}
        >
            <div className="image">
                <Skeleton
                    className="image-skeleton"
                    variant={SkeletonVariant.BLOCK}
                />
            </div>
            <div className="content">
                <HeadingSkeleton className="heading" size={HeadingSize.H2} />
                <Skeleton
                    className="text"
                    variant={SkeletonVariant.TEXT}
                    lineCount={3}
                />
                <div className="button">
                    <ButtonSkeleton />
                </div>
            </div>
        </StyledSectionPreviewBlockSkeleton>
    );
};
